<template>
<div ref="gantt"></div>
</template>

<script>
// documentation, usage and hints here:
// https://docs.dhtmlx.com/gantt/desktop__guides.html

import axios from 'axios'

import {
    gantt
} from 'dhtmlx-gantt';

export default {
    name: 'gantt',
    props: {
        userDict:[],
        isAdmin: false,
        userInfo: {},
        rw: Boolean,
        tasks: {
            type: Object,
            default () {
                return {
                    data: [],
                    links: []
                }
            }
        }
    },
    data: {
        sections: [],
        userInfo: {},
    },
    methods: {
        $_initGanttEvents: function () {
            let vm = this;
            if (!gantt.$_eventsInitialized) {
                gantt.attachEvent('onTaskSelected', (id) => {
                    let task = gantt.getTask(id);
                    this.$emit('task-selected', task);
                });
                gantt.attachEvent('onAfterTaskUpdate', function () {
                    var json = gantt.serialize()
                    vm.$emit('tasks-updated', json);
                });
                gantt.attachEvent("onLightboxSave", function (id, task, is_new) {
                    return true;
                });
                gantt.attachEvent("onBeforeTaskChanged", function (id, mode, e) {
                    var modes = gantt.config.drag_mode;
                    switch (mode) {
                        case modes.move:
                            break;
                        case modes.resize:
                            break;
                        case modes.progress:
                            if (vm.userInfo.email != undefined && !vm.isAssignee(e.assignee)) {
                                return false;
                            }
                            return true;
                            break;
                    }

                    return true;
                });
                gantt.attachEvent("onAfterTaskDrag", function (id, mode, e) {
                    var modes = gantt.config.drag_mode;
                    if (mode == modes.progress) {
                        let task = gantt.getTask(id);
                        let json = gantt.serialize();
                        vm.$emit('task-progress-changed', task, json);
                    }

                });
                gantt.attachEvent("onBeforeLightbox", function (id) {
                    var task = gantt.getTask(id);
                    task.my_template =
                        "<span id='description'>Description: </span>" + task.text + "<br/>" +
                        "<span> Assignee: " + vm.userDict[task.assignee] + "</span><br/>" +
                        "<span id='title2'>Progress: </span>" + Math.round(task.progress * 100) + " %<br/>"

                    if (vm.isAssignee(task.assignee)) {
                        gantt.config.lightbox.sections = [
                            // {
                            //     name: "assignee",
                            //     height: 20,
                            //     map_to: "assignee",
                            //     type: "select",
                            //     options: vm.userList
                            // },
                            {
                                name: "description",
                                height: 60,
                                map_to: "text",
                                type: "my_editor", // custom template
                                focus: true
                            },
                            {
                                name: "time",
                                height: 18,
                                type: "duration",
                                map_to: "auto",
                                time_format: ["%d", "%m", "%Y"]
                            },

                            // {name: "template",height:80, type:"template", map_to:"my_template"}, 
                        ];
                        gantt.config.buttons_right = ["gantt_save_btn", "gantt_cancel_btn"];
                        gantt.config.buttons_left = [];
                    } else {
                        gantt.config.lightbox.sections = [{
                            name: "template",
                            height: 80,
                            type: "template",
                            map_to: "my_template"
                        }, ];
                        gantt.config.buttons_right = ["close_btn"];
                        gantt.config.buttons_left = [];
                    }
                    gantt.resetLightbox()
                    return true;

                });
                gantt.attachEvent("onLightboxButton", function (button_id) {
                    if (button_id == "close_btn") {
                        gantt.hideLightbox();
                        vm.$emit('edit-closed', vm.$props.tasks)
                    }
                });
            }
        },
        $_initDataProcessor: function () {
            if (!gantt.$_dataProcessorInitialized) {
                gantt.createDataProcessor((entity, action, data, id) => {
                    this.$emit(`${entity}-updated`, id, action, data);
                });
                gantt.$_dataProcessorInitialized = true;
            }
        },
        isAssignee: function (assignee) {
            // checks if the assignee of the current task is the current user or a valid substitute
            console.log(this.isAdmin)
            if (assignee == this.userInfo.email || this.isAdmin) {
                // TODO: define the substitutes for an assignee 
                return true
            }
            return false
        },

    },
    updated: function () {},
    async created() {
        this.accessToken = await this.$auth.getAccessToken()
        let vm = this;
        this.userListHTML = "";
        Object.keys(this.$props.userDict).forEach(function (v) {
            vm.userListHTML += "<option value='" + v + "'>" + vm.$props.userDict[v] + "</option>"
        })
    },
    watch() {},
    mounted: function () {
        var vm = this;

        gantt.config.columns = [{
            name: "text",
            label: "Task name",
            width: "450",
            tree: true
        }, ];

        // setting tasks as read only
        gantt.config.drag_links = false;
        gantt.config.drag_move = false;
        gantt.config.drag_resize = false;

        // set class colorized (red) for overdue tasks
        gantt.templates.task_class = function (start, end, task) {
            if (task.progress == 1) return ""
            else if (task.end_date.toISOString().split('T')[0] > (new Date).toISOString().split('T')[0]) return ""
            return "colorized"

        };

        // setting date granularity
        gantt.config.scales = [{
                unit: "month",
                step: 1,
                format: "%F, %Y"
            },
            {
                unit: "week",
                step: 1,
                format: function (date) {
                    return "Week #" + gantt.date.getWeek(date);
                }
            },
        ];

        gantt.config.date_format = "%Y-%m-%d";

        gantt.locale.labels["close_btn"] = "Ok";

        gantt.locale.labels.section_template = "";

        // configuring editbox with extra fields
        gantt.form_blocks["my_editor"] = {
            render: function (sns) {
                return "<div class='dhx_cal_ltext' style='height:90px;'>" +
                    "<textarea class='editor_description' rows='3' cols='80'></textarea>" +
                    "<br/>Assignee&nbsp;" +

                    "<select class='editor_holders'>" + vm.userListHTML + "</select>" +
                    "</div>";
            },
            set_value: function (node, value, task) {
                node.querySelector(".editor_description").value = value || "";
                node.querySelector(".editor_holders").value = task.assignee || "";
            },
            get_value: function (node, task) {
                task.assignee = node.querySelector(".editor_holders").value;
                return node.querySelector(".editor_description").value;
            },
            focus: function (node) {
                var a = node.querySelector(".editor_description");
                a.select();
                a.focus();
            }
        };
        var tasks;
        tasks = this.$props.tasks
        tasks.data.forEach( function(v){
            v.progressColor='green'
        })
        this.$_initGanttEvents();
        gantt.init(this.$refs.gantt);
        gantt.parse(this.$props.tasks);
        this.$_initDataProcessor();
    },

}
</script>

<style>
@import "~dhtmlx-gantt/codebase/dhtmlxgantt.css";

.close_btn {
    margin-top: 1px;
    background-image: url("");
    width: 20px;
}
</style>
